import React, { memo, ReactNode, useState } from 'react';

import Alert from '@plasma/ui.feedback.alert';
import PopConfirm from '@plasma/ui.feedback.pop-confirm';
import Button from '@plasma/ui.general.button';
import { Icon } from '@plasma/ui.general.icon';
import Select from '@plasma/ui.input.select';
import Modal from '@plasma/ui.layout.modal';
import OverflowMenu from '@plasma/ui.navigation.overflow-menu';
import ThemeProvider from '@plasma/ui.themes.theme-provider';
import { ThemeOverride } from '@plasma/ui.utils.types';

import TopBarThemed from '../../components/top-bar-themed';
import useProductFamiliesHook from './product-families.hook';
import * as styled from './product-families.styles';
import {
  AddProfileButton, CardListContainer, CardSubtitle, CardTitle,
  FormContainer, ListContainerDiv, ListContainerItem, MenuContentArea,
  ModalContainer, StyledCard, StyledButtonContainer, StyledSimpleList,
  StyledFormWarningText, StyledFormSelect,
  StyledFormInput,  SimpleListContainer,  SimpleListFlexStartContainer,  SimpleListProductName,
  SimpleListSeparator,  SimpleListProductInfo,  SimpleListButtonContainer,  SimpleListStyledButton,
  SimpleListHeader} from './product-families.styles';
import themes from './themes';



const { Option } = Select;

export interface ProductFamiliesProps {
  children?: ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

type Props = ProductFamiliesProps & ThemeOverride;

function ProductFamilies(props: Props) {
  const { className, style, size, themeMode } = props;

  const { t,
          handleFamilyNameChange,
          handleProductNameChange,
          handleProductDescriptionChange,
          handleAddProduct,
          familyName,
          productName,
          productDescription,
          addedItems,
          ModalVisible,
          isInputVisible,
          dataToShowInCard,
          distinctProdName,
          descriptionByProdName,
          message,
          modalTitle,
          HandleSaveFamilyFromModal,
          HandleModalCancel,
          removeItemFromAddedList,
          handleEdit,
          handleDelete,
          handleVisibilityFamNameAndModal,
          handleSetBoolean,
  } = useProductFamiliesHook(props);


  const ItemComponent = ({ productdescription }) => {
    const [isMaxHeightSet, setIsMaxHeightSet] = useState(true);
    const handleMaxHeightToggle = () => {
      setIsMaxHeightSet(!isMaxHeightSet);
    };

    return (
      <div onClick={handleMaxHeightToggle}>
        <ListContainerDiv maxHeight={isMaxHeightSet}>
          <StyledSimpleList
            dataSource={productdescription}
            renderItem={(item) => (
              <ListContainerItem> {item} </ListContainerItem>
            )}
          />
        </ListContainerDiv>
      </div>
    );
  };

  const showPopConfirm = (oneItem) => {
    return(
    <PopConfirm
      title={<div>{t("sure-delete")} {oneItem.productfamilyname} ?</div>}
      onConfirm={() => handleDelete(oneItem)}
      okText={t("delete")}
      cancelText={t("cancel")}
    >
      <div>{t("delete")}</div>
    </PopConfirm>
    );
  }



  return (
    <ThemeProvider themes={themes} selectedSize={size} selectedMode={themeMode}>
      <styled.ProductFamilies className={`product-families ${className ?? ''}`.trim()} style={style}>

      <TopBarThemed topHeading={t("profile-families")}/>

      <AddProfileButton title={t("add-family")} onClick={()=>handleVisibilityFamNameAndModal()} />

      <Modal
            title={modalTitle}
            width={'max-content'}
            okText={t("save")}
            cancelText={t("cancel")}
            visible={ModalVisible}
            onCancel={() => HandleModalCancel()}
            onOk={() => HandleSaveFamilyFromModal()}
            confirmLoading={(addedItems.length === 0 || !/[a-zA-Z]/.test(familyName) || familyName.trim() === '' || familyName.trim().length === 0) ? true : false}
            destroyOnClose={true}
        >

        <ModalContainer>

          <FormContainer>
            <StyledFormInput
              placeholder={t("family-name")}
              value={familyName}
              onChange={handleFamilyNameChange}
              disabled = {isInputVisible}
            />
            <StyledFormWarningText>
              {(familyName.trim().length>0 || familyName.trim()!=='' ) ? null : "Family Name is required *"}
            </StyledFormWarningText>

            { (familyName.trim().length>0 && !/[a-zA-Z]/.test(familyName)) ?
              <StyledFormWarningText>
                {t("family-name-error")}
              </StyledFormWarningText>
            : null
            }
            <StyledFormSelect
              placeholder={t("product")}
              onChange={handleProductNameChange}
              disabled = {addedItems.length>0 ? true : false}
              value={productName}
            >
              { distinctProdName?.map((item, index)=> (
              <Option key={index} value={item}>
                {item}
              </Option>
              ))}
            </StyledFormSelect>
            <StyledFormSelect
              placeholder={t("dimention")}
              onChange={handleProductDescriptionChange}
              value={productDescription}
            >
              { descriptionByProdName?.map((item, index)=> (
              <Option key={index} value={item}>
                {item}
              </Option>
              ))}
            </StyledFormSelect>
            <StyledButtonContainer>
              <Button style={{ marginRight: '5px' }} onClick={handleAddProduct} title="Add Profile " type="secondary" suffixIcon= {{name: 'add_circle_outline'}} />
            </StyledButtonContainer>
          </FormContainer>

          <SimpleListContainer>
            <StyledSimpleList
              dataSource={addedItems}
              renderItem={(item) => (
                <SimpleListContainer>
                  <SimpleListFlexStartContainer>
                    <SimpleListProductName>{item.productName}</SimpleListProductName>
                    <SimpleListSeparator>:</SimpleListSeparator>
                    <SimpleListProductInfo>{item.productInfo}</SimpleListProductInfo>
                  </SimpleListFlexStartContainer>
                  <SimpleListButtonContainer>
                    <SimpleListStyledButton
                      key="btn1"
                      prefixIcon={{ name: 'delete_outline' }}
                      type="tertiary"
                      size="small"
                      onClick={() => removeItemFromAddedList({ productInfo: item.productInfo, productName: item.productName })}
                    />
                  </SimpleListButtonContainer>
                </SimpleListContainer>
              )}
              itemLayout="horizontal"
              header={<SimpleListHeader>{t("profile-for-family")} {familyName}</SimpleListHeader>}
              bordered
            />
          </SimpleListContainer>

        </ModalContainer>

      {message.length>0 && (
        <Alert style={{margin: '15px', width: '22vw'}}
            message={t("invalid-click")}
            description={message}
            type="warning"
            icon= {<Icon name='sentiment_dissatisfied'/>}
            showIcon
            closable = {false}
          />)
      }


      </Modal>

        <CardListContainer >
        {dataToShowInCard?.map((oneItem, index) => {

          return (

              <StyledCard isHovered={oneItem.isHovered} key={index}
                cardClassType="creationCard"
                metaCardClassType="metaCreationCard"
                onMouseEnter={(e) => handleSetBoolean(index, true)}
                onMouseLeave={(e) => handleSetBoolean(index, false)}
                border
                shadow={true}
                meta={{
                  title: <CardTitle isHovered={oneItem.isHovered}><b>{oneItem.productfamilyname}</b></CardTitle> ,
                  subtitle: <CardSubtitle> {oneItem.familyproducts.producttype} </CardSubtitle> ,
                  menuContentArea: (
                    <MenuContentArea isHovered={oneItem.isHovered}>
                      <OverflowMenu
                        items={[
                          {
                            label: `${t("edit")}`,
                            key: 'edit',
                            icon: 'ModeEditOutlineOutlined',
                            onClick: (e) => handleEdit(oneItem, e),
                          },
                          {
                            label: <div>{showPopConfirm(oneItem)}</div>,
                            key: 'delete',
                            icon: 'DeleteOutlined',
                          },
                        ]}
                      />
                    </MenuContentArea>
                  ),
                }}
              >
                <ItemComponent key={index} productdescription={oneItem.familyproducts.productdescription} />
              </StyledCard>
          );
        })

        }
        </CardListContainer>


      </styled.ProductFamilies>
    </ThemeProvider>
  );
}

export default memo(ProductFamilies) as unknown as typeof ProductFamilies;
